export default "__VITE_ASSET__D7W89qut__"